import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../stores/hook';
import language from '../../../../../utils/LanguageSettings';
import { resetHeight } from '../../../../functions/ResetHeight';
import { setPackInfo, setSubscribeModalStatus } from '../../GetStartedSlice';
import { PackInfo } from '../../../types';
import { appendUtmParams } from '../../../../../utils/Url';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperItem from '../../Items/SwiperItem';
import { CSSTransition } from 'react-transition-group';
import { A11y, Navigation, Pagination, Scrollbar } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';

interface IGenreList {
  plans: any;
  genre: {
    key: string,
    label: string,
  };
  hash: string;
  campaign: string;
}
const GenreList:React.FC<IGenreList> = (props) => {
  const { plans, genre, campaign } = props;
  const isTvBoxPage = useAppSelector(state => state.getStarted.isTvBoxPage);
  const filterChannelOrLibInfo = useAppSelector((state) => state.getStarted.filterChannelOrLibInfo);
  const link = window.myAppStrapi && window.myAppStrapi.phpButtonLink ? window.myAppStrapi.phpButtonLink : ''; 
  const campaignCodes = window.myAppStrapi && window.myAppStrapi.campaignCodeArray ? window.myAppStrapi.campaignCodeArray : {};
  const campaignCodeMap = new Map(Object.entries(campaignCodes));
  const genreRef = useRef<HTMLDivElement | null>(null);
  const [activeGenre, setActiveGenre] = useState<string | null>(campaign ? genre.key : null);
  const [isOpen, setIsOpen] = useState<boolean>(campaign ? true : false);
  const nodeRef = useRef<HTMLDivElement | null> (null);
  const swiperRef = useRef<any>(null);
  const dispatch = useAppDispatch();

  const sortedPlans = useMemo(() => {
    return [...plans].sort((a, b) => new Date(b.attributes.updatedAt).getTime() - new Date(a.attributes.updatedAt).getTime());
  }, [plans]);

  useLayoutEffect(() => {
    resetHeight();
  }, []);

  useEffect(()=>{
    if(props.hash.replace('%20',' ').toLocaleUpperCase() === "#"+genre.key.toLocaleUpperCase()){
      handleGenreClick(genre.key);
    }
  },[props.hash])

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.update();
    }
  }, [activeGenre]);

  useEffect(() => {
    resetHeight();
    if (activeGenre) {
      if (genreRef.current) {
        const offsetTop = genreRef.current.offsetTop;
        const scrollPosition = window.innerWidth < 991 ? offsetTop + 156 : offsetTop + 88;
        // const scrollPosition = window.innerWidth < 991 ? offsetTop - 55 : offsetTop - 73;
        scrollTo(scrollPosition, 800);
      }
              
    }
  }, [activeGenre]);
  
  const genreSwiperConfig = useMemo(() => {
    let config: any = {};
    const genrePlanLength = plans.length;
    switch(genrePlanLength) {
      case 1:
        config = {
          navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        modules: [Navigation, Pagination, Scrollbar, A11y],
        onSwiper: (swiper: any) => {
          swiperRef.current = swiper;
        },
      }
      break;
    case 2:
      config = {
        slidesPerView: 1.15,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        breakpoints: {
          767: {
            slidesPerView: 2,
            spaceBetween: 10,
            allowTouchMove: false,
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 8,
            allowTouchMove: true,
          }
        },
        modules: [Navigation, Pagination, Scrollbar, A11y],
        onSwiper: (swiper: any) => {
          swiperRef.current = swiper;
        },
      }
      break;
    case 3:
      config = {
        slidesPerView: 1.15,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          991: {
            slidesPerView: 3,
            spaceBetween: 10,
            allowTouchMove: false,
          },
          767: {
            slidesPerView: 2.3,
            spaceBetween: 10,
            allowTouchMove: true,
          },
          480: {
            slidesPerView: 1.15,
            spaceBetween: 8,
            allowTouchMove: true,
          }
        },
        modules: [Navigation, Pagination, Scrollbar, A11y],
        onSwiper: (swiper: any) => {
          swiperRef.current = swiper;
        },
                    
      }
      break;
      default:
        config = {
          slidesPerView: 1.15,
          spaceBetween: 8,
          slidesPerGroup: 1,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            991: {
              slidesPerView: 3.15,
              spaceBetween: 10,
              slidesPerGroup: 3
            },
            767: {
              slidesPerView: 2.3,
              spaceBetween: 10,
              slidesPerGroup: 2
            },
            480: {
              slidesPerView: 1.15,
              spaceBetween: 8,
              slidesPerGroup: 1
            }
          },
          modules: [Navigation, Pagination, Scrollbar, A11y],
          onSwiper: (swiper: any) => {
            swiperRef.current = swiper;
          },
        }
        break;
      }
        return config;        
    }, [activeGenre, plans])

  const onButtonClick = (e:React.MouseEvent<HTMLButtonElement>, packInfo: PackInfo) => {
    if (packInfo.PriceOptions.length > 1) {
      dispatch(setSubscribeModalStatus(true))
      // store the price when click
      dispatch(setPackInfo(packInfo))
    } else if (packInfo.PriceOptions && packInfo.PriceOptions.length === 1) {
      if (isTvBoxPage) {
        if (packInfo.PriceOptions[0].Campaign) {
          if (campaignCodeMap.size > 0) {
            const cpm = campaignCodeMap.get(packInfo.PriceOptions[0].Campaign);
            const d = new Date();
            d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
            const expires = "expires=" + d.toUTCString();
            document.cookie = "cpm=" + cpm + ";" + expires + ";SameSite=None;Secure;domain=.nowtv.now.com;path=/";
            window.location.href = link;
          }
        }
      } else {
        if (packInfo.PriceOptions[0].Campaign) {
          const url = 'https://ssp.nowtv.now.com/choose-plan?campaign=' + packInfo.PriceOptions[0].Campaign + '&lang=' + language;
          window.location.href = appendUtmParams(url)
        }
      }
    }
  }
  const scrollTo = (to: number, duration: number) => {
        const start = window.scrollY; const change = to - start;
        let startTime = 0;
        const animateScroll = (currentTime: number) => {
            if (startTime === 0) startTime = currentTime; 
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            const easeInOutQuad = (progress: number) => progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
            window.scrollTo(0, start + change * easeInOutQuad(progress));
            if (timeElapsed < duration) {
                requestAnimationFrame(animateScroll);
            }
        }; 
        requestAnimationFrame(animateScroll);
    };

  const renderSwiperForGenre = useCallback((genrePlans: any) => {
    return (
      <Swiper key={filterChannelOrLibInfo.filterChannelOrLibId} {...genreSwiperConfig}>
        {genrePlans.map((plan: any, index: number) => (
            <SwiperSlide key={index} >
              <SwiperItem
                imgSrc={plan.attributes.plan_img?.data?.attributes.url || ''}
                title={plan.attributes.name}
                campaignParameter={plan.attributes.campaignParameter || ''}
                description={plan.attributes.description}
                includes={plan.attributes.includes}
                stb_price={plan.attributes.stb_price}
                price={plan.attributes.price || ''}
                ott_12Mth_price={plan.attributes.ott_12Mth_price}
                stb_12Mth_price={plan.attributes.stb_12Mth_price}
                ottPriceDetail={plan.attributes.ottPriceDetail || ''}
                stbPriceDetail={plan.attributes.stbPriceDetail || ''}
                ottCampaign={plan.attributes.ott_campaign}
                stbCampaign={plan.attributes.stb_campaign}
                stb_12M_campaign={plan.attributes.stb_12M_campaign}
                PriceOptions={plan.attributes.PriceOptions}
                box_detail_id={plan.attributes.box_detail_id}
                Tagline={isTvBoxPage ? plan.attributes.TaglineSTB : plan.attributes.TaglineOTT}
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                  const packInfo = {
                    name: plan.attributes.name,
                    PriceOptions: plan.attributes.PriceOptions || [], 
                    optionsContext: plan.attributes.optionsContext
                  }
                  onButtonClick(e, packInfo)
                }}
              />
                </SwiperSlide>
            ))
        }
        <div className="swiper-button-next"></div>
        <div className="swiper-button-prev"></div>
      </Swiper>
    )
  }, [genre, plans,props.hash])
  const handleGenreClick = (genre: string) => {
    setActiveGenre(activeGenre === genre ? null : genre);
    setIsOpen(!isOpen);
  };  

  return (<>
    <div className={`genre ${activeGenre === genre.key ? 'active' : ''}`} ref={genreRef}>
      <h2 onClick={() => handleGenreClick(genre.key)}>{genre.label}</h2>
        <CSSTransition
          nodeRef={nodeRef}
          in={isOpen}
          timeout={400}
          unmountOnExit
          classNames="genre-slide" >
          <div ref={nodeRef} className="pack-row">
            {renderSwiperForGenre(sortedPlans)}
          </div>
          </CSSTransition>   
        </div>
  </>)
}

export default GenreList;